import { PasswordNormalizer, PasswordSanitizer } from "../Utils/PasswordSanitizer";


export class CustomerAccessMessageBuilder
{
    public static Sms(password: string, deviceId: string, serverId: string): string
    {
        const tutorialPage = process.env.TUTORIAL_PAGE || "https://tutorial.specteam.pl";
        const watcherPage = process.env.WATCHER_PAGE || "https://watcher.specteam.pl";
        const sanitizedPassword = PasswordSanitizer.Sanitize(password);
        const normalizedPassword = PasswordNormalizer.Normalize(sanitizedPassword);

        return `🎓 Instrukcja obsługi: 
${tutorialPage}

📱 Szybki podgląd: 
${watcherPage}#watch/${serverId}/${sanitizedPassword}

💻 Podgląd na komputerze: 
${watcherPage}#login/${serverId} 
hasło: "${normalizedPassword}"

🛜 Opcjonalnie w telefonie ustaw hotspot z nazwą "${deviceId}" i hasłem "${deviceId}password"`;
    }
}
